<ng-container>
  @if (display('stock')) {
    <div class="stock">
      <title
        direction="left"
        [style]="{
          'font-size': '16px',
          color: '#3376F6',
          'margin-bottom': '1.5rem',
        }"
      >
        #3 Actions et fonds actions
      </title>
      <div class="formControl mt">
        <div class="row">
          <div class="col col-md-12">
            <title
              [style]="{
                fontSize: '16px',
                color: '#2E557A',
                fontWeight: '500',
              }"
              direction="left"
            >
              La valeur d'une action peut chuter à 0 EUR.
            </title>
          </div>
          <div class="col col-md-12">
            <pr-input-radio
              formControlName="stock1"
              direction="column"
              [isDefault]="false"
              [toggle]="true"
              [options]="options"
              [columns]="3"
            >
            </pr-input-radio>
          </div>
        </div>
        <div class="row">
          <div class="col col-md-12">
            <title
              [style]="{
                fontSize: '16px',
                color: '#2E557A',
                fontWeight: '500',
              }"
              direction="left"
            >
              Détenir une action correspond à détenir une dette d'une
              entreprise.
            </title>
          </div>
          <div class="col col-md-12 clear-m">
            <pr-input-radio
              formControlName="stock2"
              direction="column"
              [isDefault]="false"
              [toggle]="true"
              [options]="options"
              [columns]="3"
            >
            </pr-input-radio>
          </div>
        </div>
      </div>
    </div>
  }
  @if (display('privateEquity')) {
    <div class="privateEquity">
      <title
        direction="left"
        [style]="{
          'font-size': '16px',
          color: '#3376F6',
          'margin-bottom': '1.5rem',
        }"
      >
        #4 Private equity (FCPI, FIP, FCPR)
      </title>
      <div class="formControl mt">
        <div class="row">
          <div class="col col-md-12">
            <title
              [style]="{
                fontSize: '16px',
                color: '#2E557A',
                fontWeight: '500',
              }"
              direction="left"
            >
              Investir dans ce type de produits est risqué et nécessite de
              conserver les parts pendant plus de 8 ans.
            </title>
          </div>
          <div class="col col-md-12 clear-m">
            <pr-input-radio
              formControlName="privateEquity1"
              direction="column"
              [isDefault]="false"
              [toggle]="true"
              [options]="options"
              [columns]="3"
            >
            </pr-input-radio>
          </div>
        </div>
        <div class="row">
          <div class="col col-md-12">
            <title
              [style]="{
                fontSize: '16px',
                color: '#2E557A',
                fontWeight: '500',
              }"
              direction="left"
            >
              Un investissement sur ce type de placement présente un risque de
              perte en capital en raison du risque de défaut ou baisse des
              participations acquises.
            </title>
          </div>
          <div class="col col-md-12 clear-m">
            <pr-input-radio
              formControlName="privateEquity2"
              direction="column"
              [isDefault]="false"
              [toggle]="true"
              [options]="options"
              [columns]="3"
            >
            </pr-input-radio>
          </div>
        </div>
      </div>
    </div>
  }
</ng-container>
